module.exports = __webpack_public_path__ + "media/images/training/Training -381e491e8fcc65b13e3bb7c5083644bd.jpg";